import React from 'react';

export default function ProjectCard({
                                        imgSrc,
                                        imgAlt = '',
                                        year,
                                        title,
                                        bullets = [],
                                        linkHref = '',
                                        linkText = 'Link',
                                    }) {
    return (
        <article className="oneWhy">
            <div className="imgContainer">
                <img src={imgSrc} alt={imgAlt} className="img-fluid imageAnimation" />
                {year && <span className="yearBadge">{year}</span>}
            </div>

            {year && !title && <h2>{year}</h2>}
            {title && <h2 className="cardTitle">{title}</h2>}

            {/* Textové body – držíme tvůj styl p (nezavádím ul/li) */}
            <div className="cardBody">
                {bullets.map((line, i) => (
                    <p key={i}>{line}</p>
                ))}
            </div>

            {linkHref && (
                <a
                    href={linkHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link cardLink"
                >
                    {linkText}
                </a>
            )}
        </article>
    );
}
